<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    content-class="authentication"
  >
    <v-card>
      <v-card-title class="white--text text-center">
        上傳身分證
      </v-card-title>
      <v-card-text>
        <div class="d-flex align-center pt-12 pb-4" v-for="(n, i) in 2">
        	<input type="file" :ref="`image${i}`" :accept="$accept_file_type.image" onclick="this.value = null" @change="upload(i)">
          <v-btn dark fab x-small color="indigo" v-if="images[i] && !verifying && !user.identity_verified" @click="$refs[`image${i}`][0].click()">
          	<v-icon x-small>fa-edit</v-icon>
          </v-btn>
          <div class="preview" @click="images[i] ? '' : $refs[`image${i}`][0].click()">
            <v-skeleton-loader 
              dark 
              height="100%" 
              width="100%" 
              type="image" 
              v-if="false"
            ></v-skeleton-loader>
            <template v-else>
              <template v-if="!images[i]">
                <div class="display-3">+</div>
                <div>{{ i == 0 ? '正面' : '反面' }}</div>
              </template>
              <template v-else>
                <v-img v-auth-src="images[i]" contain width="250" height="157"></v-img>
              </template>
            </template>
          </div>
          <v-btn dark fab x-small color="red" v-if="images[i] && !verifying && !user.identity_verified" @click.stop="images[i] = null; $forceUpdate()">
          	<v-icon x-small>fa-trash-alt</v-icon>
          </v-btn>
        </div>
        <v-btn 
        	color="pink"  
        	block 
          dark
          class="mt-8 mb-4" 
        	:disabled="!images.every(image => image) || verifying || !!user.identity_verified"
        	@click="submit"
        >
      		{{ verifying ? '審核中' : !!user.identity_verified ? '已經證' : '送出' }}
      	</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      images: Array(2).fill(null),
      skeletonLoader: false
    }
  },
  created() {
    this.$root.$on('authentication', this.open)
  },
  beforeDestroy() {
    this.$root.$off('authentication', this.open)
  },
  watch: {
  	dialog(newValue, oldValue) {
  		if(!newValue) {
  			Object.assign(this.$data, this.$options.data.apply(this))
  		}
      else {
        this.getUploadImage()
      }
  	},
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['verifying'])
  },
  methods: {
    open() {
      this.dialog = true
    },
    async upload(i) {
      let image = event.target.files[0]
      if(!await this.$func.fileValidation(image)) {
        return
      }
      this.images[i] = await this.$func.fileToBase64(image)
      this.$forceUpdate()
    },
    submit() {
      this.$root.$emit('loading', true)
    	this.axios.post('/member/identity', {
    		front_image: this.images[0],
        back_image: this.images[1]
    	}).then(response => {
    		this.$root.$emit('alert', 'success', '提交成功')
    		this.$store.dispatch('user/getUserInformation')
    		localStorage.setItem('unverified', true)
    		this.dialog = false
    	}).catch(() => {
    		this.$root.$emit('alert', 'error', '提交失敗')
    	}).finally(() => {
        this.$root.$emit('loading', false)
      })
    },
    async getUploadImage() {
      if(this.verifying || this.user.identity_verified) {
        this.skeletonLoader = true
        this.images[0] = await this.$func.urlToBase64(this.user.member_identity.front_image_path.replace('/api', ''))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.authentication {
  margin: 0;
  .v-card {
    background-color: $grey-2;
    .preview {
      height: 159px;
      width: 250px;
      margin: auto;
      border: white 1px dashed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: white;
      cursor: pointer;
    }
   	input[type="file"] {
      display: none;
    }
  }
}
</style>